import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export interface SafeDrivingGuideBottomSheetNaProps {
  fromDate: string;
  toDate: string;
}

export default function ({fromDate, toDate}: SafeDrivingGuideBottomSheetNaProps) {
  const {t} = useInferableTranslation();

  return (
    <div className="bottom_sheet safe_driving">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('ctn_dss_LN_guidance_driving_title')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('ctn_home_close')}
          onClick={() => window.bottomSheetClose()}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <p
            className="bottom_sheet_text"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('msg_dss_LN_guidance_driving_contents')}
          </p>

          {fromDate && toDate && (
            <div className="date_info_area">
              <p className="title">{t('ctn_dss_LN_calculation_date_range')}</p>
              <span className="date">
                {fromDate} ~ {toDate}
              </span>
            </div>
          )}

          <h3 className="title_small_b">{t('ctn_dss_LN_guidance_driving_sub_score_title')}</h3>
          <h4 className="bottom_sheet_title_sub">{t('ctn_dss_LN_guidance_driving_annual_mileage_title')}</h4>
          <p className="bottom_sheet_text">{t('msg_dss_LN_guidance_driving_annual_mileage_contents')}</p>
          <h4 className="bottom_sheet_title_sub">{t('ctn_dss_LN_guidance_driving_hard_braking_title')}</h4>
          <p className="bottom_sheet_text">{t('msg_dss_LN_guidance_driving_hard_braking_contents')}</p>
          <h4 className="bottom_sheet_title_sub">{t('ctn_dss_LN_guidance_driving_average_speed_title')}</h4>
          <p className="bottom_sheet_text">{t('msg_dss_LN_guidance_driving_average_speed_contents')}</p>
          <h4 className="bottom_sheet_title_sub">{t('ctn_dss_LN_guidance_driving_highway_speeding_title')}</h4>
          <p className="bottom_sheet_text">{t('msg_dss_LN_guidance_driving_highway_speeding_contents')}</p>
          <h4 className="bottom_sheet_title_sub">{t('ctn_dss_LN_guidance_driving_time_day_driving_title')}</h4>
          <p
            className="bottom_sheet_text"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('msg_dss_LN_guidance_driving_time_day_driving_contents')}
          </p>
        </div>

        <div className="bottom_sheet_footer bottom_sheet_footer_vertical">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose()}
          >
            {t('ctn_dss_LN_confrim')}
          </button>
        </div>
      </div>
    </div>
  );
}
